import React from "react";
import Hero from "../components/Hero";
import FourPaths from "../components/FourPaths";
import DoddHighlight from "../components/DoddHighlight";
import ServicesSection from "../components/ServicesSection";
import PlansAccepted from "../components/PlansAccepted";
import PayerStrip from "../components/PayerStrip";
import ServiceAreas from "../components/ServiceAreas";
import VideoSection from "../components/VideoSection";
import GoogleReviews from "../components/GoogleReviews";
import CTASection from "../components/CTASection";
import useSeo from "../hooks/useSeo";

export default function Home() {
  useSeo({
    title: "Ohio Home Care & DODD Provider | Caregivers Alliance Homecare — Columbus, OH",
    description: "Person-centered home care for individuals, families, County Boards, referral professionals, and private-pay clients across Ohio. Personal care, homemaker services, companionship, respite & transportation support. DODD Certified Provider. Call (614) 526-1548.",
    keywords: "Ohio home care, DODD provider Ohio, home care Columbus Ohio, HPC provider Ohio, respite care Ohio, private pay home care Columbus, Next Generation MyCare home care, family caregiver Ohio",
    path: "/",
  });
  return (
    <>
      <Hero />
      <FourPaths />
      <DoddHighlight />
      <PlansAccepted />
      <PayerStrip />
      <ServicesSection />
      <ServiceAreas />
      <VideoSection />
      <GoogleReviews />
      <CTASection />
    </>
  );
}
